import { FormField, Select } from '@cloudscape-design/components';
import { LabelPrinters } from '@parallel-fluidics/shared/constants';
import PropTypes from 'prop-types';
import React from 'react';

const options = LabelPrinters.map(({ id, name }) => ({ value: id, label: name }));

/**
 * Dropdown for choosing which label station prints. Options come from the
 * shared LabelPrinters registry, so this stays in sync with what the print
 * Cloud Functions accept. Controlled: `value` is a printer id.
 */
export default function PrinterSelect({ value, onChange }) {
  return (
    <FormField label="Printer">
      <Select
        selectedOption={options.find((option) => option.value === value) || null}
        onChange={({ detail }) => onChange(detail.selectedOption.value)}
        options={options}
      />
    </FormField>
  );
}

PrinterSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
